module.exports = __webpack_public_path__ + "img/etihad-logo.a84ba833.jpg";